<template>
  <div id="trigger-day-zero-popup" data-backdrop="static" data-keyboard="false" class="modal modal-position fade" role="dialog">
    <div class="modal-dialog" role="triggerDayZero">
      <div class="modal-content p-0">
        <div class="modal-body p-0">
          <a @click="triggerParticipantDay(false)" class="btn-close">a</a>
          <div class="row">
            <div class="col-md-12 pl-80 pr-80 invite-text pt-40 text-center">
              {{ heading }}
            </div>
            <div class="description">{{ description }}</div>
          </div>
          <div class="row download-modal pt-30 pb-40 text-center">
            <div v-if="isScheduledStart" class="schedule-buttons">
              <button class="btn br-3 mr-15 pt-8 pb-8 pl-29 pr-29 trigger-day-btn confirm" @click="showScheduleStartModal()">
                Select Start Date
              </button>
            </div>
            <div v-else>
              <button
                class="btn br-3 mr-15 pt-10 pb-10 pl-30 pr-30 trigger-day-btn cancel"
                :style="{
                  backgroundColor: cancelBtnCss.backgroundColor,
                  color: cancelBtnCss.color
                }"
                @click="triggerParticipantDay(false)"
              >
                Cancel
              </button>
              <button class="btn add-invite-btn br-3 pt-10 pb-10 pl-45 pr-45 trigger-day-btn confirm" @click="triggerParticipantDay(true)">
                Yes
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as DateTime from "../../services/date-time-functions";
import { participantStatuses } from "@/constants/authRoles";
import nprogress from "nprogress";
export default {
  name: "participant-trigger-day-zero-modal",
  components: {},
  props: {
    triggeredParticipant: {
      type: Object
    },
    showModal: {
      type: Boolean
    },
    studyId: {
      type: String
    },
    piId: {
      type: String
    },
    modalText: {
      type: Object
    },
    isScheduledStart: {
      type: Boolean
    }
  },
  data() {
    return {
      heading: this.modalText && this.modalText.heading ? this.modalText.heading : "Are you sure you want to start the study for this participant?",
      description: this.modalText && this.modalText.description ? this.modalText.description : this.isScheduledStart ? "Confirm by selecting a start date below. The study activities will be available to the participant as soon as they can confirm this request." : "",
      cancelBtnCss:
        this.modalText && this.modalText.cancelBtnCss
          ? this.modalText.cancelBtnCss
          : {
              backgroundColor: "#000000",
              color: "#ffffff"
            },
      participantLocalDate: null
    };
  },
  mounted() {},
  watch: {
    showModal() {
      if (!this.triggeredParticipant) {
        return;
      }
      if (this.showModal) {
        window.$("#trigger-day-zero-popup").modal("show");
      } else {
        window.$("#trigger-day-zero-popup").modal("hide");
      }
    }
  },
  methods: {
    triggerParticipantDay(confirmationStatus) {
      nprogress.start();
      if (!confirmationStatus) {
        this.$emit("resetParticipantDayZeroStatus", false);
        window.$("#trigger-day-zero-popup").modal("hide");
        return;
      }
      this.getLocalTimeOfParticipant(); // To get today's / current Date of the participant;
      window.$("#trigger-day-zero-popup").modal("hide");
      const self = this;
      const data = {
        participantId: this.triggeredParticipant.id,
        studyId: this.studyId,
        triggeredBy: this.piId,
        participantLocalDate: this.participantLocalDate
      };
      this.$api.triggerParticipantDayZero(data, true).then(
        response => {
          self.$emit("resetParticipantDayZeroStatus", true);
          this.$toastr.success(response.bodyText);
          nprogress.done();
          this.changeParticipantStatusIfRequired();
        },
        () => {
          self.$emit("resetParticipantDayZeroStatus", false);
          this.$toastr.error("Something went wrong while triggering day 0 for participant");
          nprogress.done();
        }
      );
    },
    changeParticipantStatusIfRequired() {
      // when these criteria are met, the participant status will change to SCREENING.
      const studyData = JSON.parse(window.localStorage.getItem("studyDetailsData"));

      if (this.triggeredParticipant.status == participantStatuses.VERIFIED && studyData.hasRTSMIntegration && studyData.screeningMilestoneAllowed) {
        this.$emit("changeParticipantStatusToScreening", this.triggeredParticipant.id);
      }
    },
    showScheduleStartModal() {
      this.$emit("toggleScheduleModal", true);
      window.$("#trigger-day-zero-popup").modal("hide");
    },
    getLocalTimeOfParticipant() {
      const participantStudyStartDate = DateTime.getLocalDateTime(new Date(), this.triggeredParticipant.participantLocalOffset);
      this.participantLocalDate = participantStudyStartDate.localDate;
    }
  }
};
</script>

<style scoped lang="scss" src="../../../public/static/fonts.scss"></style>
<style lang="scss" scoped>
#trigger-day-zero-popup {
  .modal-dialog {
    width: 500px;

    .modal-body {
      .invite-text {
        width: 100%;
        color: #666669;
        font-size: 18px;
        font-family: Roboto-Bold;
      }

      .download-modal {
        width: 100%;
        display: inline-block;
      }

      .btn-close {
        position: absolute;
        right: 11px;
        top: 10px;
        width: 12px;
        height: 12px;
        cursor: pointer !important;
        color: #fff;
        z-index: 999999;
      }

      .btn-close:hover {
        opacity: 0.3;
      }

      .btn-close:before,
      .btn-close:after {
        position: absolute;
        left: 7px;
        content: " ";
        height: 11px;
        width: 2.5px;
        background-color: #666669;
      }

      .btn-close:before {
        transform: rotate(45deg);
      }

      .btn-close:after {
        transform: rotate(-45deg);
      }
    }
  }

  .trigger-day-btn {
    border-radius: 100px;

    &.cancel:hover {
      box-shadow: none;
    }

    &.confirm {
      background-color: #1e8fe1 !important;
      border-color: #1e8fe1 !important;
      color: #fff;
    }

    &.btn-scheduled {
      background-color: #e0e0e0;
      color: #000000;
    }
  }

  .schedule-buttons {
    button {
      font-size: 14px !important;
    }
  }

  .description {
    font-size: 14px;
    padding: 15px 20px;
    text-align: center;
    color: #666669;
  }

  .row {
    display: block;
  }
}
/* For Smartphones */
@media only screen and (min-device-width: 320px) and (max-device-width: 480px) {
  .modal-dialog {
    max-width: 90%;
  }
}
</style>
